import { IPersonalPlanDay } from 'api/components/PersonalPlan/types';

import { IWorkoutExtended } from 'types/personalPlan';
import { WorkoutState } from 'types/workout';

type IAddCompletenessToWorkouts = ({
    days,
    currentDay,
}: {
    days: IPersonalPlanDay[];
    currentDay: number;
}) => IWorkoutExtended[];

export const addCompletenessToWorkouts: IAddCompletenessToWorkouts = ({ days, currentDay }) =>
    days.map(({ workouts, day_number }) => {
        const [workout] = workouts;

        if (day_number === currentDay) return { ...workout, completeness: WorkoutState.availableNow, day_number };

        if (day_number > currentDay) return { ...workout, completeness: WorkoutState.notAvailable, day_number };

        return { ...workout, completeness: WorkoutState.completed, day_number };
    });
